import React from 'react';
import { Users2, Mail, Phone } from 'lucide-react';

// SupportTeamCard — Sprint D item 3.6 + 3.10.
// Renders the configured Support Team for the principal's account, with
// mailto + tel links. Source: support_team_assignments via /api/client/overview.

export default function SupportTeamCard({ members = [] }) {
  if (!members.length) return null;
  return (
    <div data-testid="support-team-card" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-gray-500 mb-3">
        <Users2 className="w-3 h-3" />
        Your support team
      </div>
      <ul className="space-y-3">
        {members.map((m) => (
          <li key={m.id} data-testid={`support-team-member-${m.id}`} className="flex items-start justify-between gap-3 text-[13px]">
            <div className="min-w-0">
              <div className="text-white font-medium truncate">{m.name}</div>
              <div className="text-[11px] text-gray-500">{m.role_label}</div>
            </div>
            <div className="flex items-center gap-2">
              {m.email && (
                <a
                  href={`mailto:${m.email}`}
                  className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-white/[0.05]"
                  title={m.email}
                >
                  <Mail className="w-3.5 h-3.5" />
                </a>
              )}
              {m.phone && (
                <a
                  href={`tel:${m.phone.replace(/\s+/g, '')}`}
                  className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-white/[0.05]"
                  title={m.phone}
                >
                  <Phone className="w-3.5 h-3.5" />
                </a>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
